import { getActiveElement as h } from "../../../helpers/dom/getActiveElement.js";
import { handlePopoverTabKey as x } from "./handlePopoverTabKey.js";
const I = (t, e, d) => {
  var c;
  const s = t != null && t.hasInnerRole() || t == null ? void 0 : t.type, g = s && ["listbox", "menu", "tree"].includes(s), m = s && ["application", "combobox", "composite", "group"].includes(s), f = e === "inline", y = () => {
    setTimeout(() => {
      var i, a;
      h() === t.api.elements.floating && !t.getVirtualFocus && ((a = (i = t.list.current) == null ? void 0 : i[0]) == null || a.focus());
    });
  }, r = (i) => {
    var l, u;
    const a = t.getVirtualFocus !== void 0;
    if (i.key === "Tab" && x(t, i), i.key === "PageUp" && !a && ((l = t.list.current[0]) == null || l.focus()), i.key === "PageDown" && !a) {
      const b = Math.max((t == null ? void 0 : t.list.current.length) - 1, 0);
      (u = t.list.current[b]) == null || u.focus();
    }
    t.disabledAutoToggle || A(t, i);
  }, n = t.interactions.getFloatingProps({
    onFocus: y,
    onKeyDown: r
  });
  return {
    ...n,
    "aria-activedescendant": m ? n == null ? void 0 : n["aria-activedescendant"] : void 0,
    "aria-orientation": g ? n == null ? void 0 : n["aria-orientation"] : void 0,
    role: s,
    style: {
      ...d,
      ...f ? {} : (c = t == null ? void 0 : t.api) == null ? void 0 : c.floatingStyles
    }
  };
}, A = (t, e) => {
  t.type !== "listbox" || e.key !== "ArrowUp" || t.activeIndex !== 0 || t.setShowWithReason(!1, e.nativeEvent, "list-navigation");
};
export {
  I as composePopoverFloatingProps
};
